.container.container-super-admin .actionsSave<template>
  <div class="dashboard">       
    <Sidebar/>
    <div class="page">
      <div class="content dashboard superAdmin">
        <div class="container container-super-admin">
          <div class="container-inner" v-if="hasReady">
            <!-- Seção: Informações da Empresa -->
            <div class="section-title">
              <h4>Informações da Empresa</h4>
              <p>Preencha os dados básicos da empresa</p>
            </div>
            <div class="row">
              <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <div class="form-label">
                    <label>Razão Social<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="tradeName"
                      placeholder="Digite a razão social"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <div class="form-label">
                    <label>Nome Fantasia<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="name"
                      placeholder="Digite o nome fantasia"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <div class="form-label">
                    <label>CNPJ<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="idFiscal"
                      placeholder="Digite o CNPJ"
                      v-mask="'##.###.###/####-##'"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <div class="form-label">
                    <label>E-mail<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="email"
                      placeholder="Digite o e-mail"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Telefone<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="phone"
                      placeholder="Digite o telefone"
                      v-mask="'(##) #####-####'"
                    />
                  </div>
                </div>
              </div>

              <!-- Seção: Endereço -->
              <div class="col-form-inner col-12 col-md-12 col-lg-12">
                <div class="section-title">
                  <h4>Endereço</h4>
                  <p>Informe o endereço completo da empresa</p>
                </div>
              </div>
              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>CEP<v-tooltip text="Informe o CEP" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="00000-000"
                      v-model="postcode"
                      v-mask="'#####-###'"
                      @input="getCep"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <div class="form-label">
                    <label>Endereço</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      v-model="address"
                      placeholder="Digite o endereço"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Número</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      v-model="addressNumber"
                      placeholder="Nº"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-4 col-md-4 col-lg-4">
                <div class="form-group">
                  <div class="form-label">
                    <label>Complemento</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      v-model="addressComplement"
                      placeholder="Digite o complemento"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Bairro</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      v-model="neighborhood"
                      placeholder="Digite o bairro"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Cidade</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      v-model="city"
                      placeholder="Digite a cidade"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Estado</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      v-model="county"
                      placeholder="Digite o estado"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>País</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      v-model="country"
                      placeholder="Digite o país"
                    />
                  </div>
                </div>
              </div>

              <!-- Seção: Configurações do Sistema -->
              <div class="col-form-inner col-12 col-md-12 col-lg-12">
                <div class="section-title">
                  <h4>Configurações do Sistema</h4>
                  <p>Defina as configurações básicas do sistema</p>
                </div>
              </div>
              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Tipo de Sistema<v-tooltip text="Selecione o sistema" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="form-input">
                    <select
                      class="form-control"
                      v-model="typeSystem"
                    >
                      <option value="" disabled selected>Selecione o tipo</option>
                      <option value="1">Weeduc</option>
                      <option value="2">Weflix</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Plano de Teste</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="number"
                      class="form-control"
                      v-model="testPlan"
                      placeholder="Digite o plano de teste"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Status do Carrinho</label>
                  </div>
                  <div class="form-input">
                    <select
                      class="form-control"
                      v-model="cartStatus"
                    >
                      <option value="" disabled selected>Selecione o status</option>
                      <option value="1">Ativo</option>
                      <option value="0">Inativo</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Cor da Empresa<v-tooltip text="Campo obrigatório" location="top">
                      <template v-slot:activator="{ props }">
                        <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                      </template>
                    </v-tooltip></label>
                  </div>
                  <div class="inputsColors">
                    <input type="color" id="body" name="body" v-model="color" />
                    <input
                      type="text" 
                      required
                      class="form-control"
                      v-model="color"
                      placeholder="#ffffff"
                    />
                  </div>
                </div>
              </div>

              <!-- Seção: Dados Bancários -->
              <div class="col-form-inner col-12 col-md-12 col-lg-12">
                <div class="section-title">
                  <h4>Dados Bancários</h4>
                  <p>Informe os dados bancários da empresa</p>
                </div>
              </div>
              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Banco</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      v-model="bank"
                      placeholder="Código do banco"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Agência</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      v-model="branch"
                      placeholder="Número da agência"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <div class="form-label">
                    <label>Dígito da Agência</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      v-model="digitBranch"
                      placeholder="Dígito"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Conta</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      v-model="account"
                      placeholder="Número da conta"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Dígito da Conta</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="text"
                      class="form-control"
                      v-model="digitAccount"
                      placeholder="Dígito"
                    />
                  </div>
                </div>
              </div>

              <!-- Seção: Outros Dados -->
              <div class="col-form-inner col-12 col-md-12 col-lg-12">
                <div class="section-title">
                  <h4>Outros Dados</h4>
                  <p>Configure informações adicionais da empresa</p>
                </div>
              </div>
              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Tempo Total de Vídeo</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="number"
                      class="form-control"
                      v-model="videoTimeTotal"
                      placeholder="Tempo total (min)"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Tempo Usado de Vídeo</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="number"
                      class="form-control"
                      v-model="videoTimeUsed"
                      placeholder="Tempo usado (min)"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Percentual do Cliente</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="number"
                      step="0.01"
                      class="form-control"
                      v-model="percentualClient"
                      placeholder="Percentual (%)"
                    />
                  </div>
                </div>
              </div>

              <div class="col-form-inner col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="form-label">
                    <label>Valor da Transação</label>
                  </div>
                  <div class="form-input">
                    <input
                      type="number"
                      step="0.01"
                      class="form-control"
                      v-model="transactionValue"
                      placeholder="Valor (R$)"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="actionsSave">
              <button class="btnSave btnCancel" @click="$router.push('/admin/empresas')" :disabled="!hasReady">
                Voltar
              </button>
              <button class="btnSave" @click="editLayoutCompany" :disabled="!hasReady">
                <span v-if="hasReady">Salvar</span>
                <span v-else>Salvando...</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!hasReady" class="loader-overlay">
        <div class="loader"></div>
      </div>
      <Loader :hasReady="hasReady"/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Sidebar from '@/components/Weflix/Sidebar-SuperAdmin.vue'
import Footer from '@/components/Admin/Footer/footerSuperAdmin.vue'
import { mapState } from 'vuex'
import superAdmin from '@/utils/superAdmin';
import Loader from '@/components/Weflix/Loader.vue'

export default {
  data() {
    return {
      hasReady: false,
      id: null,
      tradeName: null,
      name: null,
      idFiscal: null,
      email: null,
      phone: null,
      postcode: null,
      address: null,
      addressNumber: null,
      addressComplement: null,
      neighborhood: null,
      city: null,
      county: null,
      country: null,
      typeSystem: null,
      testPlan: null,
      cartStatus: null,
      color: null,
      bank: null,
      branch: null,
      digitBranch: null,
      account: null,
      digitAccount: null,
      videoTimeTotal: null,
      videoTimeUsed: null,
      percentualClient: null,
      transactionValue: null,
      anticipation: 0,
      videoComments: 0,
      intallmentCheckout: 0,
      imagePath: null,
      imageFinalPath: null,
      idFolderVideoteca: null,
      recipientCode: null,
      split: null
    }
  },

  components: {
    Sidebar,
    Footer,
    Loader
  },

  computed: {
    ...mapState(['token','currentCompanyCreated']),
  },

  methods: {
    async getCep() {
      if (this.postcode && this.postcode.length === 8) {
        try {
          const response = await fetch(`https://viacep.com.br/ws/${this.postcode}/json/`)
          const data = await response.json()
          if (!data.erro) {
            this.address = data.logradouro
            this.neighborhood = data.bairro
            this.city = data.localidade
            this.county = data.uf
            this.country = 'Brasil'
          }
        } catch (error) {
          console.error('Erro ao buscar CEP:', error)
        }
      }
    },

    async editLayoutCompany() {
      this.hasReady = false
      const payload = {
        id: this.id,
        idFiscal: this.idFiscal?.replace(/\D/g, ''),
        name: this.name,
        country: this.country,
        county: this.county,
        city: this.city,
        address: this.address,
        addressNumber: this.addressNumber,
        addressComplement: this.addressComplement,
        postcode: this.postcode?.replace(/\D/g, ''),
        testPlan: this.testPlan,
        typeSystem: this.typeSystem,
        anticipation: this.anticipation,
        videoComments: this.videoComments,
        cartStatus: this.cartStatus,
        intallmentCheckout: this.intallmentCheckout,
        color: this.color,
        bank: this.bank,
        branch: this.branch,
        digitBranch: this.digitBranch,
        account: this.account,
        digitAccount: this.digitAccount,
        videoTimeTotal: this.videoTimeTotal,
        videoTimeUsed: this.videoTimeUsed,
        idFolderVideoteca: this.idFolderVideoteca,
        tradeName: this.tradeName,
        email: this.email,
        phone: this.phone?.replace(/\D/g, ''),
        percentualClient: this.percentualClient,
        transactionValue: this.transactionValue,
        recipientCode: this.recipientCode,
        neighborhood: this.neighborhood,
        split: this.split
      }
      try {
        const response = await superAdmin.editLayoutCompany(this.token, payload)
        this.hasReady = true
        this.$router.push('/admin/empresas/')
      } catch (error) {
        console.error(error)
        this.hasReady = true
      }
    },
    async getCompany() {
    const id = this.$route.params.slug
        
    try {
      const response = await superAdmin.createCompanyById(this.token, id)
      this.id = response.id
      this.idFiscal = response.idFiscal
      this.name = response.name
      this.country = response.country
      this.county = response.county
      this.city = response.city
      this.address = response.address
      this.addressNumber = response.addressNumber
      this.addressComplement = response.addressComplement
      this.postcode = response.postcode
      this.testPlan = response.testPlan
      this.typeSystem = response.typeSystem
      this.anticipation = response.anticipation
      this.videoComments = response.videoComments
      this.cartStatus = response.cartStatus
      this.intallmentCheckout = response.intallmentCheckout
      this.color = response.color
      this.bank = response.bank
      this.branch = response.branch
      this.digitBranch = response.digitBranch
      this.account = response.account
      this.digitAccount = response.digitAccount
      this.videoTimeTotal = response.videoTimeTotal
      this.videoTimeUsed = response.videoTimeUsed
      this.idFolderVideoteca = response.idFolderVideoteca
      this.tradeName = response.tradeName
      this.email = response.email
      this.phone = response.phone
      this.percentualClient = response.percentualClient
      this.transactionValue = response.transactionValue
      this.recipientCode = response.recipientCode
      this.neighborhood = response.neighborhood
      this.split = response.split
      this.hasReady = true
    } catch (error) {
      console.error('Erro ao carregar dados da empresa:', error)
      }
    }
  },
  created() {
    const id = this.$route.params.slug
    this.getCompany()
  }
}
</script>

<style>
.content.dashboard > .container {
  padding-bottom: 70px;
}

.dashboard {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #eef0fc;
  margin: 0;
  position: relative;
}

.content.dashboard {
  background-color: transparent;
  margin: 0;
  width: 100%;
  padding: 10px 10px;
  min-height: 100%;
  flex: 1;
}

.col-form-inner {
  padding: 0px;
}

.form-group {
  margin: 5px 10px;
}

.container.container-super-admin {
    width: 84%;
    left: 15.5%;
    position: absolute;
    max-width: 100%;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    padding: 30px;
    margin-top: 20px;
    margin-bottom: 40px;
}

.container.container-super-admin .container-inner {
    padding: 0;
    margin: 0;
    background-color: transparent;
    box-shadow: none;
    border-radius: 0;
}

.container.container-super-admin .section-title {
    margin: 40px 0 25px 0;
    padding-top: 10px;
    padding-bottom: 15px;
    border-bottom: 2px solid #e8e8e8;
    text-align: left;
}

.container.container-super-admin .section-title:first-of-type {
    margin-top: 0;
}

.container.container-super-admin .section-title h4 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0 0 6px 0;
    line-height: 1.3;
    text-align: left;
}

.container.container-super-admin .section-title p {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0;
    line-height: 1.5;
    text-align: left;
}

.container.container-super-admin .row {
    margin: 0 -10px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
}

.container.container-super-admin .col-form-inner {
    padding: 0 10px;
    margin-bottom: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.container.container-super-admin .col-form-inner.col-2 {
    flex: 0 0 16.666%;
    max-width: 16.666%;
}

.container.container-super-admin .col-form-inner.col-3 {
    flex: 0 0 25%;
    max-width: 25%;
}

.container.container-super-admin .col-form-inner.col-4 {
    flex: 0 0 33.333%;
    max-width: 33.333%;
}

.container.container-super-admin .col-form-inner.col-6 {
    flex: 0 0 50%;
    max-width: 50%;
}

.container.container-super-admin .col-form-inner.col-8 {
    flex: 0 0 66.666%;
    max-width: 66.666%;
}

.container.container-super-admin .col-form-inner.col-12 {
    flex: 0 0 100%;
    max-width: 100%;
}

.container.container-super-admin .form-group {
    margin: 0;
}

.container.container-super-admin .form-label {
    margin-bottom: 8px;
}

.container.container-super-admin .form-label label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #374151;
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 0;
}

.container.container-super-admin .form-label svg {
    color: #9ca3af;
    font-size: 0.75rem;
}

.container.container-super-admin .form-input {
    margin-bottom: 0;
}

.container.container-super-admin .form-control {
    width: 100%;
    padding: 10px 14px;
    font-size: 0.875rem;
    color: #1a1a1a;
    background-color: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

.container.container-super-admin .form-control:focus {
    outline: none;
    border-color: #250891;
    box-shadow: 0 0 0 3px rgba(37, 8, 145, 0.1);
}

.container.container-super-admin .form-control:hover {
    border-color: #9ca3af;
}

.container.container-super-admin .form-input small {
    display: block;
    margin-top: 6px;
    font-size: 0.75rem;
    color: #6b7280;
    line-height: 1.4;
}

.container.container-super-admin hr {
    width: 100%;
    margin: 30px 0;
    border: none;
    border-top: 1px solid #e5e7eb;
}

.container.container-super-admin .actionsSave {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;
    padding-top: 30px;
    border-top: 2px solid #e8e8e8;
    position: relative;
    right: 0;
}

.container.container-super-admin .btnSave {
    background-color: #250891;
    color: white;
    padding: 12px 32px;
    border: none;
    border-radius: 6px;
    font-size: 0.9375rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(37, 8, 145, 0.2);
    position: relative;
}

.container.container-super-admin .btnSave:hover:not(:disabled) {
    background-color: #1f0770;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(37, 8, 145, 0.3);
}

.container.container-super-admin .btnSave:active:not(:disabled) {
    transform: translateY(0);
}

.container.container-super-admin .btnSave:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
    opacity: 0.6;
}

.container.container-super-admin .btnCancel {
    background-color: #6b7280;
}

.container.container-super-admin .btnCancel:hover:not(:disabled) {
    background-color: #4b5563;
}

.container.container-super-admin .inputsColors {
    display: flex;
    gap: 10px;
    align-items: center;
}

.container.container-super-admin input[type="color"] {
    width: 50px;
    height: 38px;
    padding: 0;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    cursor: pointer;
}

.container.container-super-admin select.form-control {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23374151' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    padding: 6px 14px;
    padding-right: 36px;
}

/* Responsividade */
@media (max-width: 1200px) {
    .container.container-super-admin {
        width: 90%;
        left: 10%;
        padding: 25px;
    }
}

@media (max-width: 768px) {
    .container.container-super-admin {
        width: 100%;
        left: 0;
        padding: 20px;
        margin-top: 10px;
        border-radius: 0;
    }
    
    .container.container-super-admin .col-form-inner {
        margin-bottom: 15px;
    }
    
    .container.container-super-admin .actionsSave {
        margin-top: 30px;
        padding-top: 20px;
        flex-direction: column;
    }
    
    .container.container-super-admin .btnSave {
        width: 100%;
        padding: 14px 32px;
        margin-left: 0 !important;
    }
}

textarea.textarea_input {
  height: 150px !important;
  font-family: "Poppins" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 28px !important;
  resize: none !important;
  outline: none !important;
  padding: 0.5rem 0.75rem !important;
  color: #5f5f5f !important;
  background-color: #fff !important;
  border: 1px solid #dbdcde !important;
  box-shadow: none !important;
  width: 100% !important;
  border-radius: 5px !important;
}

hr {
  width: 95%;
  margin: 25px auto;
}

.actionsSave {
  width: 100%;
  text-align: right;
  padding: 20px;
}

.btnSave {
  background: #250891;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.btnSave:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.inputsColors {
  display: flex;
  gap: 10px;
  align-items: center;
}

input[type="color"] {
  width: 50px;
  height: 38px;
  padding: 0;
  border: 1px solid #dbdcde;
  border-radius: 5px;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #250891;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>